import { sideBarTemplate } from './side-bar.template';
import { sideBarStyles } from './side-bar.styles';
import { FASTElement } from '@microsoft/fast-element';
import { NatGenDesignSystem } from '../../natgen-design-system';
import { backgroundColorContext } from '../../context/background-context';
import { fillColor, getToken } from '../../design-tokens';
import { isDark } from '../../utilities/is-dark';

/**
 * @element natgen-side-bar
 */
export class NatGenSideBar extends FASTElement {
    connectedCallback(): void {
        super.connectedCallback();
                
        var backgroundToken = getToken('ui-nav-bar-color-background');
        fillColor.setValueFor(this, backgroundToken);
        backgroundColorContext.provide(this, isDark(backgroundToken.getValueFor(this)));
    }
}

export const natGenSideBarDefinition = NatGenSideBar.compose({
    name: `${NatGenDesignSystem.prefix}-side-bar`,
    template: sideBarTemplate,
    styles: sideBarStyles
});
